<div>
  <fieldset>
    <legend class="group-label fw-bold">{{ componentLabel }}</legend>
    <rfa-errors [control]="postalCodeControl"></rfa-errors>
    <rfa-errors [control]="houseNumberControl"></rfa-errors>
    <rfa-errors [control]="houseNumberAdditionControl"></rfa-errors>
    @if (addressCheckState().status !== 'IDLE') {
      <rfa-errors [control]="cityControl"></rfa-errors>
      <rfa-errors [control]="streetControl"></rfa-errors>
    }
    <div class="group-container">
      <div class="group-input group-input-medium">
        <crnt-form-control>
          <crnt-form-control-label slot="label">
            <label class="fw-normal" [for]="postalCodeControl.id">
              {{ postalCodeControl.options.label }}
            </label>
          </crnt-form-control-label>
          @if (postalCodeControl.options.helpText) {
            <crnt-form-control-help-text slot="help">
              {{ postalCodeControl.options.helpText }}
            </crnt-form-control-help-text>
          }
          <crnt-text-input
            [state]="postalCodeControl.hasError() ? 'invalid' : 'enabled'"
          >
            <input
              type="text"
              [id]="postalCodeControl.id"
              [name]="postalCodeAutocompleteId"
              [autocomplete]="postalCodeAutocompleteId"
              [formControl]="postalCodeControl"
              [wlTrackFieldfocus]="focusChangeTrackConfig(postalCodeControl)"
              [wlAutomationId]="postalCodeControl.options.dataAutomationId"
              [attr.aria-describedby]="ariaDescribedBy(postalCodeControl)"
            />
          </crnt-text-input>
        </crnt-form-control>
      </div>
      <div class="group-input group-input-small">
        <crnt-form-control>
          <crnt-form-control-label slot="label">
            <label class="fw-normal" [for]="houseNumberControl.id">
              {{ houseNumberControl.options.label }}
            </label>
          </crnt-form-control-label>
          @if (houseNumberControl.options.helpText) {
            <crnt-form-control-help-text slot="help">
              {{ houseNumberControl.options.helpText }}
            </crnt-form-control-help-text>
          }
          <crnt-text-input
            [state]="houseNumberControl.hasError() ? 'invalid' : 'enabled'"
          >
            <input
              type="text"
              [id]="houseNumberControl.id"
              [name]="houseNumberAutocompleteId"
              [autocomplete]="houseNumberAutocompleteId"
              [formControl]="houseNumberControl"
              [wlTrackFieldfocus]="focusChangeTrackConfig(houseNumberControl)"
              [wlAutomationId]="houseNumberControl.options.dataAutomationId"
              [attr.aria-describedby]="ariaDescribedBy(houseNumberControl)"
            />
          </crnt-text-input>
        </crnt-form-control>
      </div>
      <div class="group-input group-input-small">
        <crnt-form-control>
          <crnt-form-control-label slot="label">
            <label class="fw-normal" [for]="houseNumberAdditionControl.id">
              {{ houseNumberAdditionControl.options.label }}
            </label>
          </crnt-form-control-label>
          @if (houseNumberAdditionControl.options.helpText) {
            <crnt-form-control-help-text slot="help">
              {{ houseNumberAdditionControl.options.helpText }}
            </crnt-form-control-help-text>
          }
          <crnt-text-input
            [state]="
              houseNumberAdditionControl.hasError() ? 'invalid' : 'enabled'
            "
          >
            <input
              type="text"
              [id]="houseNumberAdditionControl.id"
              [formControl]="houseNumberAdditionControl"
              [wlTrackFieldfocus]="
                focusChangeTrackConfig(houseNumberAdditionControl)
              "
              [wlAutomationId]="
                houseNumberAdditionControl.options.dataAutomationId
              "
              [attr.aria-describedby]="
                ariaDescribedBy(houseNumberAdditionControl)
              "
            />
          </crnt-text-input>
        </crnt-form-control>
      </div>
    </div>
    <div class="address-container">
      @if (addressCheckState().status === 'PENDING') {
        <div class="d-flex justify-content-center py-1">
          <crnt-icon icon="spinner-third" animation="spin"></crnt-icon>
        </div>
      }
      @if (
        addressCheckState().status === 'SUCCESS' && !showStreetAndCityInputs()
      ) {
        <div class="py-1 px-2">
          <div data-cs-mask>{{ streetAddress() }}</div>
          <button
            class="btn btn-link p-0"
            type="button"
            variant="tertiary"
            (click)="showStreetAndCityInputs.set(true)"
            wlAutomationId="show-street-and-city-inputs"
          >
            {{ changeAddressLabel }}
          </button>
        </div>
      }
    </div>
    @if (addressCheckState().status === 'ERROR') {
      <crnt-callout variant="negative">
        {{ addressCheckError }}
      </crnt-callout>
    }
    @if (showStreetAndCityInputs()) {
      <div class="group-container mt-1">
        <div class="group-input group-input-fill">
          <crnt-form-control>
            <crnt-form-control-label slot="label">
              <label class="fw-normal" [for]="streetControl.id">
                {{ streetControl.options.label }}
              </label>
            </crnt-form-control-label>
            @if (streetControl.options.helpText) {
              <crnt-form-control-help-text slot="help">
                {{ streetControl.options.helpText }}
              </crnt-form-control-help-text>
            }
            <crnt-text-input
              [state]="streetControl.hasError() ? 'invalid' : 'enabled'"
            >
              <input
                type="text"
                [id]="streetControl.id"
                [formControl]="streetControl"
                [wlTrackFieldfocus]="focusChangeTrackConfig(streetControl)"
                [wlAutomationId]="streetControl.options.dataAutomationId"
                [attr.aria-describedby]="ariaDescribedBy(streetControl)"
              />
            </crnt-text-input>
          </crnt-form-control>
        </div>
        <div class="group-input group-input-fill">
          <crnt-form-control>
            <crnt-form-control-label slot="label">
              <label class="fw-normal" [for]="cityControl.id">
                {{ cityControl.options.label }}
              </label>
            </crnt-form-control-label>
            @if (cityControl.options.helpText) {
              <crnt-form-control-help-text slot="help">
                {{ cityControl.options.helpText }}
              </crnt-form-control-help-text>
            }
            <crnt-text-input
              [state]="cityControl.hasError() ? 'invalid' : 'enabled'"
            >
              <input
                type="text"
                [id]="cityControl.id"
                [formControl]="cityControl"
                [wlTrackFieldfocus]="focusChangeTrackConfig(cityControl)"
                [wlAutomationId]="cityControl.options.dataAutomationId"
                [attr.aria-describedby]="ariaDescribedBy(cityControl)"
              />
            </crnt-text-input>
          </crnt-form-control>
        </div>
      </div>
    }
  </fieldset>
</div>
